import { FiltersBar, useFilterUpdate } from '@ingrid/luterkort-react';

import { CarrierFilter } from './carrier-filter';
import { SearchFilter } from './search-filter';
import { useCarrierContractListFilter } from './useCarrierContractListFilter';

export function Filters() {
  const { search } = useCarrierContractListFilter();

  useFilterUpdate('search', search);

  return (
    <FiltersBar.Row>
      <SearchFilter />

      <FiltersBar.Toolbar>
        <CarrierFilter />
      </FiltersBar.Toolbar>
    </FiltersBar.Row>
  );
}
